import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum RecurringJobSecurityRight {
    CanAccess = 19000,
    Manage = 19001,
}

export class RecurringJobSecurityModule extends BaseSecurityModule<RecurringJobSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.RecurringJobs,
            [
                { _id: RecurringJobSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: RecurringJobSecurityRight.Manage, name: 'Manage', basic: true },
            ] as SecurityRight<RecurringJobSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
